export default {
  methods: {
    onClickBannerDeposit(link) {
      if (!link) return
      window.open(this.fixUrlProtocol(link), '_blank')
    },
    fixUrlProtocol(url) {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url
      }
      return url
    },
  },
}